enum PlatformPush {
  FCM = "FCM",
}

export default PlatformPush;
